import React, { useState, useEffect } from "react";
import styles from "./PlanATripSuccessMain.module.css";
import CircularProgress from "@material-ui/core/CircularProgress";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { useLocation, useHistory, Link } from "react-router-dom";
import queryString from "query-string";
import { confirmPayment } from "../../../config/confirmPayment";

import icon1 from "../../../assets/images/Icon1.svg";
import icon2 from "../../../assets/images/Icon2.svg";
import icon3 from "../../../assets/images/Icon3.svg";
import {HiArrowRight} from 'react-icons/hi';

import moment from "moment";

export default function PlanATripSuccessMain() {
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(true);

  const { search } = useLocation();
  const { provider, trxref, tx_ref } = queryString.parse(search);
  const [application_id,setApplication_id] = useState("")

  const [first, setFirst] = useState("")
  const [second, setSecond] = useState("")
  const [third, setThird] = useState("")

  const history = useHistory();

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }

      if (provider !== undefined) {
        const confirmIt = async (token) => {
          const confirm = await confirmPayment(token, provider, search);
          if (confirm.data) {
            console.log(confirm.data);
            setLoading(false);
            setApplication_id(confirm.data.data.application_id)

            const myDate = new Date(confirm.data.data.application.visa_package.created_at);
            const add = myDate.setDate(myDate.getDate() + confirm.data.data.application.visa_package.processing_time.min)
            const myDate1 = new Date(confirm.data.data.application.visa_package.created_at);
            const addMore = myDate1.setDate(myDate1.getDate() + confirm.data.data.application.visa_package.processing_time.max)
            
            const date1 = moment(new Date(add));
            const firstDate = date1.format("Do MMM");
            setFirst(firstDate)

            setSecond(confirm.data.data.application.visa_package.processing_time.min);

            const date2 = moment(new Date(addMore));
            const thirdDate = date2.format("Do MMM");
            setThird(thirdDate)

          } else if (confirm.error) {
            console.log(confirm.error);
            history.push("/dashboard/plan-a-trip");
          }
        };
        confirmIt(item.value.token);
      } else {
        history.push("/dashboard/plan-a-trip");
      }
    }
    getWithExpiry("userData");

  }, []);
  return (
    <div>
        {loading ? (
            <div className={styles.loder}>
         <div className="spinner-border" role="status"></div>
         </div>
      ) : (
        <div>


<div>
      <div className={styles.first}>
        <h1 className={styles.firstHead}>Thank You!</h1>
        <h1 className={styles.firstHead2}>
          Your visa application payment was successful
        </h1>
        <br />
        {/* <p className={styles.firstPera}>Order Details</p> */}
      </div>
      <div className={styles.second}>
        <h1 className={styles.secondHead}>Next Step</h1>
        <div className={styles.boxes}>
          <div className={styles.box}>
            <img src={icon1} alt="Icon 1" className={styles.image}  />
            <div className={styles.boxIn}>
                <h1 className={styles.boxHead}>Fill application form</h1>
                <p className={styles.boxPera}>Complete our biodata form and Upload all documents </p>
                <Link to={`/dashboard/my-applications/application-center/${application_id}`}>
                <p className={styles.boxEnd}>Start application&nbsp;&nbsp;<HiArrowRight size={20} color="#ffffff" style={{backgroundColor: "#F78500",height: "25px", width: "25px"}} /></p>
                </Link>
            </div>
          </div>
          <div className={styles.box1}>
            <img src={icon2} alt="Icon 2" className={styles.image1} />
            <div className={styles.boxIn1}>
                <h1 className={styles.box1Head}>Visa processing</h1>
                <p className={styles.box1Pera}>Visa will be applied on <span style={{color:"#FD6B3B"}}>{first}.</span><br /> Processing usually takes <span style={{color:"#FD6B3B"}}>{second}</span> Working Days </p>
            </div>
          </div>
          <div className={styles.box1}>
            <img src={icon3} alt="Icon 3" />
            <div className={styles.boxIn1}>
                <h1 className={styles.box1Head}>Fill application form</h1>
                <p className={styles.box1Pera}>Visa expected by <span style={{color:"#FD6B3B"}}>{third}.</span> Dowload Visa from Visapro trips section once approved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

</div>
      )}





      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
      />
    </div>
  );
}
